import { ForumUser, Thread } from '@/app/models/forum/new-forum.model'
import { Dispatch, SetStateAction, useMemo } from 'react'
import { useIntl } from 'react-intl'
import SectionContainer from '../Layout/SectionContainer/SectionContainer'
import ForumDistribution from './ForumDistribution'
import ForumInformation from './ForumInformation'
import ForumReferenceThread from './ForumReferenceThread'

export interface ForumTopicContainerProps {
    title: string
    description: string
    referenceStoreList: any[]
    userList: ForumUser[]
    storeList: { store_id: string }[]
    referenceThreadUserList?: ForumUser[]
    referenceTitle?: string
    referenceId?: string
    id?: string
    onSetTitle: Dispatch<SetStateAction<string>>
    onSetDescription: Dispatch<SetStateAction<string>>
    onSetReference: (thread: Thread) => void
    onSetDistribution: Dispatch<SetStateAction<any[]>>
    onSetUsers: Dispatch<SetStateAction<ForumUser[]>>
    onRemoveReferenceUser: (id: string, enable?: boolean) => void
    smartFilter: any
    setSmartFilter: (value: any) => void
}

const ForumTopicContainer = ({
    onSetReference,
    onSetDistribution,
    onSetUsers,
    onRemoveReferenceUser,
    referenceStoreList,
    referenceThreadUserList,
    userList,
    storeList,
    referenceId,
    referenceTitle,
    id,
    smartFilter,
    setSmartFilter,
    ...props
}: ForumTopicContainerProps) => {
    const intl = useIntl()
    const informationTitleInputLabel = useMemo(
        () =>
            intl.formatMessage({
                id: 'modals.new.forum.title.topic',
                defaultMessage: 'Topic title',
            }),
        [intl]
    )

    const onReferenceChange = (thread: Thread) => {
        onSetReference(thread)
    }

    return (
        <>
            <SectionContainer>
                <ForumReferenceThread
                    onSetReference={onReferenceChange}
                    referenceId={referenceId}
                    referenceTitle={referenceTitle}
                />
                <ForumInformation {...props} titleInputLabel={informationTitleInputLabel} />
                <ForumDistribution
                    onSetDistribution={onSetDistribution}
                    onSetUsers={onSetUsers}
                    onRemoveReferenceUser={onRemoveReferenceUser}
                    referenceStoreList={referenceStoreList}
                    referenceThreadUserList={referenceThreadUserList}
                    selectedUsers={userList}
                    storeList={storeList}
                    isEdit={!!id}
                    tableConfigId='forum_topic'
                    smartFilter={smartFilter}
                    setSmartFilter={setSmartFilter}
                />
            </SectionContainer>
        </>
    )
}

export default ForumTopicContainer
